module.exports = __webpack_public_path__ + "static/img/qijian@2x.2be1ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industry-version/qijian@2x.png
// module id = 925
// module chunks = 2